import { InheritanceStatus, QuestInterface } from "@swivl-mono/types";
import { DarkPopover } from "@swivl-mono/ui";

import { Member } from "../../../../../../Models/Member/Member.Current";
import { QuestsModel } from "../../../../../../Models/Quests/Quests.Model";

interface Props {
  quest: QuestInterface;
  editNameClicked(e: React.MouseEvent): void;
  closeMenu(): void;
}
export function BoardQuestItemOverflowMenu({ quest, editNameClicked, closeMenu }: Props) {
  if (Member.isInChildOrg) {
    if (quest.inheritance === InheritanceStatus.IS_CHILD) {
      return (
        <DarkPopover clickedOutside={closeMenu}>
          <a
            onClick={() => {
              if (window.confirm("Are you sure you want to revert this quest?")) {
                QuestsModel.revertToParent(quest);
              }
            }}
          >
            <b>Revert</b> to Parent
          </a>
          <a onClick={() => QuestsModel.cloneToStandAlone(quest)}>
            <b>Clone</b> to standalone
          </a>
        </DarkPopover>
      );
    }
    if (quest.inheritance === InheritanceStatus.IS_PARENT) {
      return (
        <DarkPopover clickedOutside={closeMenu}>
          <a onClick={() => QuestsModel.makeQuestChild(quest)}>
            <b>Make</b> child
          </a>
          <a onClick={() => QuestsModel.cloneToStandAlone(quest)}>
            <b>Clone</b> to standalone
          </a>
        </DarkPopover>
      );
    }
  }
  // Normal Standalone
  return (
    <DarkPopover clickedOutside={closeMenu}>
      <a onClick={editNameClicked}>
        <b>Edit</b> name
      </a>
      <a
        onClick={() => {
          QuestsModel.duplicateQuest(quest, quest.name + " (copy)");
        }}
      >
        <b>Duplicate</b> quest
      </a>

      <a
        onClick={() => {
          if (window.confirm("Are you sure you want to delete this quest?")) {
            QuestsModel.deleteQuest(quest);
          }
        }}
      >
        <b>Delete</b>
      </a>
    </DarkPopover>
  );
}
